// document.addEventListener('DOMContentLoaded', async function () {
//   const addonBox = document.querySelector('.addon-box[data-addon-handle]');
//   if (!addonBox) return;

//   const handle = addonBox.dataset.addonHandle;
//   const titleEl = addonBox.querySelector('[data-addon-title]');
//   const priceEl = addonBox.querySelector('[data-addon-price]');
//   const addOnBtn = addonBox.querySelector('.addon-plus');

//   // Dawn product form (base product)
//   const form = document.querySelector('form[action*="/cart/add"]');
//   if (!form) return;

//   let addonVariantId = null;

//   /* ----------------------------
//      1) Load addon product data
//   ----------------------------- */
//   try {
//     const res = await fetch(`/products/${handle}.js`);
//     if (!res.ok) throw new Error('Addon product not found');

//     const product = await res.json();

//     titleEl.textContent = product.title;

//     const v = product.variants?.[0];
//     if (!v) throw new Error('No variant found');

//     addonVariantId = Number(v.id);

//     const currency = window.Shopify?.currency?.active || 'USD';
//     priceEl.textContent = (v.price / 100).toLocaleString(undefined, {
//       style: 'currency',
//       currency
//     });

//   } catch (e) {
//     titleEl.textContent = 'Add-on unavailable';
//     priceEl.textContent = '';
//     addOnBtn.disabled = true;
//     return;
//   }

//   /* ----------------------------
//      Helpers
//   ----------------------------- */

//   // Get selected base variant id
//   function getBaseVariantId() {
//     const fd = new FormData(form);
//     const id = fd.get('id');
//     return id ? Number(id) : null;
//   }

//   // Dawn-proof base quantity
//   function getBaseQuantity() {
//     let qtyInput =
//       form.querySelector('input[name="quantity"]') ||
//       (form.id
//         ? document.querySelector(`input[name="quantity"][form="${CSS.escape(form.id)}"]`)
//         : null) ||
//       document.querySelector('quantity-input input[name="quantity"]') ||
//       document.querySelector('input.quantity__input');

//     const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
//     return Number.isFinite(qty) && qty > 0 ? qty : 1;
//   }

//   /* ----------------------------
//      2) PLUS click behavior
//      Base qty respected
//      Addon qty = 1 always
//   ----------------------------- */
//   addOnBtn.addEventListener('click', async function () {
//     const baseVariantId = getBaseVariantId();
//     const baseQty = getBaseQuantity();

//     if (!baseVariantId) {
//       alert('Please select product options first.');
//       return;
//     }

//     addOnBtn.disabled = true;

//     try {
//       const addRes = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           items: [
//             { id: baseVariantId, quantity: baseQty },
//             { id: addonVariantId, quantity: 1 } // ✅ FIXED
//           ]
//         })
//       });

//       if (!addRes.ok) throw new Error('Add to cart failed');

//       window.location.href = '/cart';
//     } catch (err) {
//       alert('Failed to add base + add-on.');
//       addOnBtn.disabled = false;
//     }
//   });

//   // Default Add to Cart = base only (Dawn handles it)
// });












document.addEventListener('DOMContentLoaded', async function () {
  const addonBox = document.querySelector('.addon-box[data-addon-handle]');
  if (!addonBox) return;

  const handle = addonBox.dataset.addonHandle;

  const titleEl = addonBox.querySelector('[data-addon-title]');
  const priceEl = addonBox.querySelector('[data-addon-price]');

  // Qty UI
  const qtyInput = addonBox.querySelector('[data-addon-qty-input]');
  const qtyMinus = addonBox.querySelector('.addon-qty-minus');
  const qtyPlus = addonBox.querySelector('.addon-qty-plus');

  // Dawn product form (base product)
  const form = document.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  let addonVariantId = null;

  /* ----------------------------
     1) Load addon product data
  ----------------------------- */
  // try {
  //   const res = await fetch(`/products/${handle}.js`);
  //   if (!res.ok) throw new Error('Addon product not found');

  //   const product = await res.json();
  //   titleEl.textContent = product.title;

  //   const v = product.variants?.[0];
  //   if (!v) throw new Error('No variant found');

  //   addonVariantId = Number(v.id);

  //   const currency = window.Shopify?.currency?.active || 'USD';
  //   priceEl.textContent = (v.price / 100).toLocaleString(undefined, {
  //     style: 'currency',
  //     currency
  //   });
  // } catch (e) {
  //   titleEl.textContent = 'Add-on unavailable';
  //   priceEl.textContent = '';
  //   if (qtyInput) qtyInput.disabled = true;
  //   if (qtyMinus) qtyMinus.disabled = true;
  //   if (qtyPlus) qtyPlus.disabled = true;
  //   return;
  // }

try {
  const res = await fetch(`/products/${handle}.js`);
  if (!res.ok) throw new Error('Addon product not found');

  const product = await res.json();

  let catalogNumber = '';

  try {
    const pageRes = await fetch(`/products/${handle}`);

    if (pageRes.ok) {
      const pageHtml = await pageRes.text();
      const doc = new DOMParser().parseFromString(pageHtml, 'text/html');

      const catalogEl = doc.querySelector('.product-catalog-number-js');

      if (catalogEl) {
        catalogNumber =
          catalogEl.dataset.catalogNumber?.trim() ||
          catalogEl.textContent.trim() ||
          '';
      }
    }
  } catch (catalogErr) {
    catalogNumber = '';
  }

  titleEl.textContent = catalogNumber
    ? `${catalogNumber} | ${product.title}`
    : product.title;

  const v = product.variants?.[0];
  if (!v) throw new Error('No variant found');

  addonVariantId = Number(v.id);

  const currency = window.Shopify?.currency?.active || 'USD';

  priceEl.textContent = (v.price / 100).toLocaleString(undefined, {
    style: 'currency',
    currency
  });
} catch (e) {
  titleEl.textContent = 'Add-on unavailable';
  priceEl.textContent = '';

  if (qtyInput) qtyInput.disabled = true;
  if (qtyMinus) qtyMinus.disabled = true;
  if (qtyPlus) qtyPlus.disabled = true;

  return;
}

  /* ----------------------------
     Helpers
  ----------------------------- */
  function clampQty(val) {
    const n = parseInt(val, 10);
    // allow 0 (means not adding add-on)
    return Number.isFinite(n) && n >= 0 ? n : 0;
  }

  function getAddonQty() {
    if (!qtyInput) return 0;
    return clampQty(qtyInput.value);
  }

  function setAddonQty(val) {
    if (!qtyInput) return;
    qtyInput.value = clampQty(val);
  }

  // Extract line item properties like properties[foo]
  function extractLineItemProperties(fd) {
    const props = {};
    for (const [key, value] of fd.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match) {
        const propName = match[1];
        if (typeof value === 'string' && value.trim() === '') continue;
        props[propName] = value;
      }
    }
    return props;
  }

  function getBaseVariantIdFromForm(fd) {
    const id = fd.get('id');
    return id ? Number(id) : null;
  }

  function getBaseQuantityFromForm(fd) {
    const q = parseInt(fd.get('quantity') || '1', 10);
    return Number.isFinite(q) && q > 0 ? q : 1;
  }

  function getSellingPlanFromForm(fd) {
    const sp = fd.get('selling_plan');
    return sp ? Number(sp) : null;
  }

  /* ----------------------------
     2) Qty controls
  ----------------------------- */
  if (qtyInput) {
    qtyInput.addEventListener('change', () => setAddonQty(qtyInput.value));
    qtyInput.addEventListener('blur', () => setAddonQty(qtyInput.value));
  }
  if (qtyMinus) qtyMinus.addEventListener('click', () => setAddonQty(getAddonQty() - 1));
  if (qtyPlus) qtyPlus.addEventListener('click', () => setAddonQty(getAddonQty() + 1));

  /* ----------------------------
     3) Hook REAL Add-to-Cart
     If addonQty > 0 => add base + add-on in ONE request
     Else => let Dawn handle base only
  ----------------------------- */
  form.addEventListener(
    'submit',
    async function (e) {
      const addonQty = getAddonQty();

      // If qty is 0, don't interfere; Dawn adds base normally
      if (addonQty <= 0) return;

      if (!addonVariantId) return;

      e.preventDefault();
      e.stopPropagation();

      const fd = new FormData(form);
      const baseVariantId = getBaseVariantIdFromForm(fd);

      if (!baseVariantId) {
        alert('Please select product options first.');
        return;
      }

      const baseQty = getBaseQuantityFromForm(fd);
      const properties = extractLineItemProperties(fd);
      const sellingPlan = getSellingPlanFromForm(fd);

      const baseItem = { id: baseVariantId, quantity: baseQty };
      if (Object.keys(properties).length) baseItem.properties = properties;
      if (sellingPlan) baseItem.selling_plan = sellingPlan;

      const submitBtn =
        form.querySelector('[type="submit"][name="add"]') ||
        form.querySelector('button[type="submit"]') ||
        form.querySelector('input[type="submit"]');

      if (submitBtn) submitBtn.disabled = true;

      try {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              baseItem,
              { id: addonVariantId, quantity: addonQty }
            ]
          })
        });

        if (!addRes.ok) throw new Error('Add failed');

        window.location.href = '/cart';
      } catch (err) {
        alert('Sorry, this item is currently out of stock.');
        if (submitBtn) submitBtn.disabled = false;
      }
    },
    true
  );
});
